import {ReactElement} from "react";
import {ReactComponent as ArgentinaFlag} from "components/Icons/flags/argentina.svg";
import {ReactComponent as AustraliaFlag} from "components/Icons/flags/australia.svg";
import {ReactComponent as AustriaFlag} from "components/Icons/flags/austria.svg";
import {ReactComponent as ChileFlag} from "components/Icons/flags/chile.svg";
import {ReactComponent as GermanyFlag} from "components/Icons/flags/germany.svg";
import {ReactComponent as FranceFlag} from "components/Icons/flags/france.svg";
import {ReactComponent as ItalyFlag} from "components/Icons/flags/italy.svg";
import {ReactComponent as NewZealandFlag} from "components/Icons/flags/new-zealand.svg";
import {ReactComponent as PortugalFlag} from "components/Icons/flags/portugal.svg";
import {ReactComponent as SouthAfricaFlag} from "components/Icons/flags/south-africa.svg";
import {ReactComponent as SpainFlag} from "components/Icons/flags/spain.svg";
import {ReactComponent as SwitzerlandFlag} from "components/Icons/flags/switzerland.svg";
import {ReactComponent as USAFlag} from "components/Icons/flags/usa.svg";

export interface FlagProps {
    country: string | null | undefined
    className?: string
}

export function Flag(props: FlagProps): ReactElement | null {
    if (props.country == null) {
        return null;
    }
    const lowerCaseCountryName = props.country.toLowerCase();
    const countryName = TRANSLATIONS_DICTIONARY[lowerCaseCountryName] ?? lowerCaseCountryName;
    switch (countryName) {
        case 'argentinien': return <ArgentinaFlag className={props.className ?? undefined} />;
        case 'australien':  return <AustraliaFlag className={props.className ?? undefined} />;
        case 'österreich':  return <AustriaFlag className={props.className ?? undefined} />;
        case 'chile':       return <ChileFlag className={props.className ?? undefined} />;
        case 'deutschland': return <GermanyFlag className={props.className ?? undefined} />;
        case 'frankreich':  return <FranceFlag className={props.className ?? undefined} />;
        case 'italien':     return <ItalyFlag className={props.className ?? undefined} />;
        case 'neuseeland':  return <NewZealandFlag className={props.className ?? undefined} />;
        case 'portugal':    return <PortugalFlag className={props.className ?? undefined} />;
        case 'südafrika':   return <SouthAfricaFlag className={props.className ?? undefined} />;
        case 'schweiz':     return <SwitzerlandFlag className={props.className ?? undefined} />;
        case 'spanien':     return <SpainFlag className={props.className ?? undefined} />;
        case 'usa':         return <USAFlag className={props.className ?? undefined} />;
        default: return null;
    }
}

const TRANSLATIONS_DICTIONARY: Record<string, string> = {
    // french
    "argentine": "argentinien",
    "australie": "australien",
    "autriche": "österreich",
    "chili": "chile",
    "germanie": "deutschland",
    "france": "frankreich",
    "italie": "italien",
    "nouvelle-zélande": "neuseeland",
    "portugal": "portugal",
    "afrique du sud": "südafrika",
    "suisse": "schweiz",
    "espagne": "spanien",
    "amérique": "usa",

    // italian
    "argentina": "argentinien",
    "australia": "australien",
    "austria": "österreich",
    "cile": "chile",
    "germania": "deutschland",
    "francia": "frankreich",
    "italia": "italien",
    "nuova zelanda": "neuseeland",
    "portogallo": "portugal",
    "sudafrica": "südafrika",
    "svizzera": "schweiz",
    "spagna": "spanien",
    "america": "usa",
};